import { env } from '~/env';

export const PowerliftingLiveConfig = {
  baseUrl: env.VITE_POWERLIFTING_LIVE_BASE_URL ?? 'https://se.test.powerliftinglive.com',
};
